// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"589":"50c25a66","732":"783bc47a"}[chunkId] + ".chunk.js";
};